import NewsItemFooter from 'components/NewsItem/NewsItemFooter';
import * as React from 'react';
import styled from 'styled-components';
import { INewsItem } from 'types/news';

interface IProps {
  item: INewsItem;
  className?: string;
  readMoreText: string;
  featured?: boolean;
  imageHeight?: number;
}

type Props = IProps;

export const NewsItem: React.SFC<Props> = props => {
  return (
    <Container className={props.className}>
      <Background
        background={props.item.image}
        style={props.imageHeight ? { height: props.imageHeight } : {}}
      >
        {props.featured && <Featured>Featured Article</Featured>}
      </Background>
      <Bottom
        featured={props.featured}
        readMoreText={props.readMoreText}
        id={props.item.id}
        content={props.item.content}
        title={props.item.title}
        author={props.item.author}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const Background = styled.div<{ background?: string }>`
  background: url(${p => p.background});
  width: 100%;
  height: 450px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  @media (max-width: 750px) {
    height: 200px;
  }
`;

const Featured = styled.div`
  background: black;
  padding: 10px;
  font-weight: 600;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
  font-size: 16px;
  text-transform: uppercase;
  color: white;
`;

const Bottom = styled(NewsItemFooter)<{ featured?: boolean }>`
  color: #222
    ${p =>
      p.featured &&
      `
  background-color: #3a506b;
  color: white;
  `};
`;
export default NewsItem;



// WEBPACK FOOTER //
// ./src/components/NewsItem/NewsItem.tsx